import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getUserWorkspaces } from "../lib/user";
import { UserWorkspacesResponse } from "../common/dto/onboarding/user-workspaces-response.dto";

const userWorkspacesQueryKeys = {
    all: () => ["userWorkspaces"],
    withEntities: (withEntities: boolean) => [
        ...userWorkspacesQueryKeys.all(),
        withEntities,
    ],
};

export function useUserWorkspaces(
    withEntities: boolean,
    options?: Omit<
        UseQueryOptions<UserWorkspacesResponse | void>,
        "queryKey" | "queryFn"
    >,
) {
    return useQuery({
        queryKey: userWorkspacesQueryKeys.withEntities(withEntities),
        queryFn: () => getUserWorkspaces(withEntities),
        ...options,
    });
}
